<app-connection-dialog fxLayout="column">
  <button style="background-color: transparent;border: aliceblue;margin-left: 361px; margin-top:-2em" (click)="closeDialog()">
    <img style="width: 3em ; cursor: pointer" src="assets/icons/close-gray.svg" alt="close" />
  </button>  <img src="assets/icons/resend-code.svg" alt="img" />
  <h2 class="first-part">Lien de confirmation envoyé</h2>

  <span class="second-part">
    Nous venons d'envoyé un e-mail contenant un lien de confirmation à
    <strong> {{ data.email }}</strong>
    , pour valider votre compte et terminer votre inscription.<br />

    <strong
      >Si vous n'avez pas reçu l'émail cliquer sur <br> " Renvoyer " pour recevoir
      un nouveau lien de confirmation.</strong
    >
  </span>
  <div>
    <button
      class="btn-resend"
      mat-button
      id="btnCounter"
      (click)="countDown(59); confirmationMail();"
      [disabled]="(timer$ | async) === 0 ? !isCount : isCount"
    >
      {{
      (timer$ | async) === 0
        ? "RENVOYER"
        : "00:" + ((timer$ | async) < 10 ? "0" + (timer$ | async) : (timer$ | async))
      }}


    </button>

  </div>
</app-connection-dialog>
